import { FileUploadStatusCode, SetupFrameInformation } from 'components/pages/InventoryManagement/Setup/Setup.types';
import { isCompletedState } from 'components/pages/InventoryManagement/Setup/utils';

export const getDisplayProgressPercentage = (data: SetupFrameInformation): number => {
  if (isCompletedState(data.processingState) && data.uploadStatusCode === FileUploadStatusCode.SUCCESS) {
    return 100;
  }

  return data?.progressPercentage ?? 0;
};

const hasRenderableProgress = (data?: SetupFrameInformation): boolean => {
  return isCompletedState(data?.processingState) || data?.progressPercentage !== undefined;
};

const ProgressRenderer = ({ data }: { data?: SetupFrameInformation }): React.ReactElement => {
  if (!data || !hasRenderableProgress(data)) {
    return <span>-</span>;
  }

  const progressPercentage = getDisplayProgressPercentage(data);

  return <p>{progressPercentage}%</p>;
};

export default ProgressRenderer;
